module.exports = __webpack_public_path__ + "img/2fea8de.png";